
import { axios } from '@/utils/request'

const api = {
  options: '/adminapi/daoshi/options',
  daoshiManageList: '/adminapi/daoshi/daoshiManageList',
  manageDetail: '/adminapi/daoshi/manageDetail',
  editManage: '/adminapi/daoshi/editManage',
  memberList: '/adminapi/daoshi/memberList',
  memberDetail: '/adminapi/daoshi/memberDetail',
  memberEdit: '/adminapi/daoshi/memberEdit',
  manageDelete: '/adminapi/daoshi/manageDelete',
  memberDelete: '/adminapi/daoshi/memberDelete',
  memberImport: '/adminapi/daoshi/memberImport',
  shenheUrls: '/adminapi/daoshi/shenheUrls',
}

export default api

export function getOptions(parameter) {
  return axios({
    url: api.options,
    method: 'get',
    params: parameter
  })
}

export function daoshiManageList(parameter) {
  return axios({
    url: api.daoshiManageList,
    method: 'get',
    params: parameter
  })
}
export function manageDetail(parameter) {
  return axios({
    url: api.manageDetail,
    method: 'get',
    params: parameter
  })
}

export function editManage(parameter) {
  return axios({
    url: api.editManage,
    method: 'post',
    data: parameter
  })
}

export function getApplyMemberList(parameter) {
  return axios({
    url: api.memberList,
    method: 'post',
    data: parameter
  })
}
export function memberEdit(parameter) {
  return axios({
    url: api.memberEdit,
    method: 'post',
    data: parameter
  })
}

export function memberDetail(parameter) {
  return axios({
    url: api.memberDetail,
    method: 'get',
    params: parameter
  })
}

export function applyDelete(parameter) {
  return axios({
    url: api.manageDelete,
    method: 'get',
    params: parameter
  })
}

export function memberDelete(parameter) {
  return axios({
    url: api.memberDelete,
    method: 'get',
    params: parameter
  })
}

export function memberImport(parameter) {
  return axios({
    url: api.memberImport,
    method: 'post',
    data: parameter
  })
}
export function getShenheUrls(parameter) {
  return axios({
    url: api.shenheUrls,
    method: 'get',
    params: parameter
  })
}

